import { render, staticRenderFns } from "./SeriesGridSection.vue?vue&type=template&id=14ed99fe&"
import script from "./SeriesGridSection.vue?vue&type=script&lang=js&"
export * from "./SeriesGridSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports